/*
 *
 * Copyright 2021-2023, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */
import React from 'react';
import {AnchorButton} from "@blueprintjs/core";
import {IconNames} from "@blueprintjs/icons";
import {Intent} from "@blueprintjs/core/lib/esm/index";
import {WrcApp} from './registry-common/src/WrcApp.js';
import './App.css';

function App() {
    let welcome = (
        <h3>Welcome to the Lung Pre-Cancer Registry.</h3>
    );

    let app_layout = {
        main_layout: "vertical",
        ld_child_grandchild_layout: "horizontal"
    };

    let login_footer =  (
        <AnchorButton href={'https://lci-selfservice.whiterivercomputing.com/'}
        minimal={true}
        intent={Intent.PRIMARY}
        icon={IconNames.HELP}
        text={'Forgot your password?'}
        target={'_blank'}
        style={{float: 'left'}}/>
    );

    return (
        <div className="App">
            <WrcApp
                app_layout={app_layout}
                project_name="Lung Pre-Cancer Registry"
                site_name="Lung Pre-Cancer Registry"
                title="Dashboard"
                component_alignment="left"
                login_footer={login_footer}
                tiered_roles={true}
                welcome={welcome} />
        </div>
    );
}

export default App;
